import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { createGuid } from '@office-start/guid-generator';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { OfficeWorkload } from '@office-start/officehome-types';
import { httpPost } from '@office-start/xhr-service';
import { createRequestConfig } from './createRequestConfig';
export function performActionsInternal(options, feedbackId, action, actionPayload) {
    return __awaiter(this, void 0, void 0, function () {
        var objectId, tenantId, substrateApi, inMockMode, officeApiRoot, aadClientId, officeComponentContext, application, requestId, requestConfig, apiRoot, mockParams, url, actionBody;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    objectId = options.objectId, tenantId = options.tenantId, substrateApi = options.substrateApi, inMockMode = options.inMockMode, officeApiRoot = options.officeApiRoot, aadClientId = options.aadClientId;
                    return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    officeComponentContext = _a.sent();
                    application = officeComponentContext.workload === OfficeWorkload.Hwa
                        ? 'OfficeComApp'
                        : 'OfficeComHome';
                    requestId = createGuid();
                    requestConfig = createRequestConfig(requestId, objectId, tenantId, aadClientId, application, true);
                    apiRoot = substrateApi;
                    if (inMockMode) {
                        apiRoot = officeApiRoot;
                        mockParams = {
                            mockParam: 'mockrecommendeddelete',
                        };
                    }
                    url = "".concat(apiRoot, "/peoplepredictionsb2/v2/myanalyticsaction");
                    actionBody = {
                        FeedbackId: feedbackId,
                        Action: action,
                        ActionPayload: actionPayload,
                    };
                    if (inMockMode) {
                        // TODO: need to set up mock api?
                        return [2 /*return*/, Promise.resolve()];
                    }
                    return [2 /*return*/, httpPost(KnownInstrumentationEvents.OfficeFeedAction, "OfficeFeedAction" /* KnownRequestInstrumentationEvents.OfficeFeedAction */, url, actionBody, requestConfig, options.jwtAuthEnabled, options.getAccessToken, options.officeApiRoot, options.correlationId, 'Substrate', mockParams).catch(function (error) {
                            console.log('Failed to perform action ' + actionBody.Action);
                            throw error;
                        })];
            }
        });
    });
}
//# sourceMappingURL=performActionsInternal.js.map